import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ClinicAppointmentTypeFormGroupMapping {
  id?: number;
  typeID: number;
  groupName: string;
  branchID: number;
  requireForEachAppointment: boolean;
  isActive: boolean;
  createdBy?: number;
  createdDT?: string;
  updatedBy?: number;
  updatedDT?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClinicAppointmentTypeFormGroupService {
  private apiUrl = environment.API_URL + 'ClinicAppointmentTypeFormGroup/';

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'ApiKey': environment.API_KEY
    });
  }

  /**
   * Assign or update form group for an appointment type
   */
  saveFormGroupMapping(mapping: ClinicAppointmentTypeFormGroupMapping): Observable<any> {
    return this.http.post(
      this.apiUrl + 'SaveFormGroupMapping',
      mapping,
      { headers: this.getHeaders() }
    );
  }

  /**
   * Get form group mapping by appointment type ID
   */
  getFormGroupByAppointmentType(typeId: number): Observable<any> {
    const formData = new FormData();
    formData.append('typeId', typeId.toString());

    return this.http.post(
      this.apiUrl + 'GetFormGroupByAppointmentType',
      formData
    );
  }

  /**
   * Get all mappings for a branch
   */
  getAllMappingsByBranch(branchId: number): Observable<any> {
    const formData = new FormData();
    formData.append('branchId', branchId.toString());

    return this.http.post(
      this.apiUrl + 'GetAllMappingsByBranch',
      formData
    );
  }

  /**
   * Check if appointment type has form group assigned
   */
  hasFormGroup(typeId: number): Observable<any> {
    const formData = new FormData();
    formData.append('typeId', typeId.toString());

    return this.http.post(
      this.apiUrl + 'HasFormGroup',
      formData
    );
  }

  /**
   * Get all forms for a specific appointment type
   * This is the main method used when patient books appointment
   */
  getFormsForAppointmentType(typeId: number, branchId: number): Observable<any> {
    const formData = new FormData();
    formData.append('typeId', typeId.toString());
    formData.append('branchId', branchId.toString());

    return this.http.post(
      this.apiUrl + 'GetFormsForAppointmentType',
      formData
    );
  }

  /**
   * Remove form group assignment from appointment type
   */
  removeFormGroupMapping(typeId: number): Observable<any> {
    const formData = new FormData();
    formData.append('typeId', typeId.toString());

    return this.http.post(
      this.apiUrl + 'RemoveFormGroupMapping',
      formData
    );
  }
}
